(ns manage.poi.view
  (:require [common.widgets.page :as page]
            [linked.core :as l]
            [manage.poi.labels.ocps]
            [manage.poi.labels.view :refer [labels]]
            [manage.poi.locations.ocps]
            [manage.poi.locations.view :refer [locations]]
            [manage.poi.selectors.view :refer [selectors]]
            [uix.core :refer [$]]))

(def poi-tabs
  (l/map :locations
         {:label "Locations"
          :view locations
          :container-sx #js {:overflow "hidden"}}

         :selectors
         {:label "Selectors"
          :view selectors
          :container-sx #js {:overflow "hidden"}}

         :labels
         {:label "Labels"
          :view labels
          :container-sx #js {:overflow "hidden"}}))

(defn poi-page []
  ($ page/page
     ($ page/page-header
        {:title "POI"
         :tabs poi-tabs})
     ($ page/active-tab
        {:tabs poi-tabs})))
